import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import VerticalBarChart from "../../../ceo/analysis/competitive/charts/vertical-bar";
import TypeformContent from "../../../typeform/TypeformContent";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";

class TeamReportsSection2Step4 extends PureComponent {
  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    let val = data[team_id][key];

    if (!val) {
      return 0;
    }

    return val;
  };

  get EarningPerShare() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "Earnings Per Share")
      });
    });

    return data;
  }

  get left_content() {
    return (
      <span>
        EPS is a very common metric that investors track to evaluate the
        performance of a company and assess the value of owning a share of the
        company. Investors expect the EPS to grow over time.
        <br />
        <br />
        <div className="formula">
          <div className="formula first-child">
            AVERAGE EARNINGS
            <br />
            PER SHARE (EPS)
          </div>
          =
          <div className="formula">
            AVERAGE NET PROFITS
            <hr />
            SHARES OUTSTANDING
          </div>
        </div>
        <br />
        <br />
        How could you maximize your EPS?
        <br />
        <br />
        To learn more about EPS, please review the following content:
        <br />
        <TypeformLink
          title="Earnings Per Share"
          url={TypeformUrls.EARNINGS_PER_SHARE}
        />
      </span>
    );
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <VerticalBarChart prefix="$" data={this.EarningPerShare} />
        <div className="text-center" style={{ marginTop: "-20px" }}>
          Earnings Per Share
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="xs"
            {...TypeformContent.EARNINGS_PER_SHARE}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Earnings Per Share (EPS)"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection2Step4;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-4.js